module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iNTBweCIgaGVpZ2h0PSI1MHB4IiB2aWV3Qm94PSIwIDAgNTAgNTAiPgo8cG9seWxpbmUgcG9pbnRzPSI0LjMzLDE5LjY0IDkuNywyNy42OSAxNS45NSwyMC41NCAiLz4KPHBhdGggZD0iTTkuNzEsMjcuNjlDOC4zNiwxNi44MSwxNi42OCw4LjM4LDI2LjA2LDguMDNjOS4zNy0wLjM1LDE3LjI1LDYuOTcsMTcuNiwxNi4zNQoJYzAuMzUsOS4zOC02Ljk3LDE3LjI2LTE2LjM1LDE3LjYiLz4KPHBvbHlsaW5lIHBvaW50cz0iMjYuNjgsMTYuMDYgMjYuNjgsMjUuODkgMzUuNjIsMjUuODkgIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/stroke/history.svg
// module id = ./node_modules/graphcool-styles/icons/stroke/history.svg
// module chunks = 0